import React, { Component, Fragment } from 'react';
import FontAwesome from 'react-fontawesome';

let channelLogos =
{
	"Mystery": "images/HMyst-24_LOGO_Black_v2.png",
	"Channel": "images/HC_Logo_New_Black.png",
	"Family": "images/HF_LOGO_Black.png"
}

class OtherProvidersMobileTable extends Component {

	render() {

		return (
			<Fragment>
				<div className="single-mobile-provider">
					<div className="row">
						<div className="col-xs-6"><h3 className="mobile-provider-heading">Other Provider:</h3></div>
						<div className="col-xs-6 align-center">
							<img className="mobile-provider-logo" src="images/DIRECTV_STREAM_2021_logo.png" alt="Direct TV Stream" />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6 align">
							<img className="mobile-channel-logo" alt={this.props.order[0]} src={channelLogos[this.props.order[0]]} />
						</div>
						<div className="col-xs-6 align-center">
							{this.props.channel === "hd"
								?
								<h3>N/A</h3>
								:
								<FontAwesome className='provider-check' name='check-circle' />
							}
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<img className="mobile-channel-logo" alt={this.props.order[1]} src={channelLogos[this.props.order[1]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<img className="mobile-channel-logo" alt={this.props.order[2]} src={channelLogos[this.props.order[2]]} />
						</div>
						<div className="col-xs-6 align-center">
							{this.props.channel === "hd"
								?
								<h3>N/A</h3>
								:
								<FontAwesome className='provider-check' name='check-circle' />

							}
						</div>
					</div>
				</div>
				<div className="single-mobile-provider">
					<div className="row">
						<div className="col-xs-6"><h3 className="mobile-provider-heading">Other Provider:</h3></div>
						<div className="col-xs-6 align-center">
							<img className="mobile-provider-logo" src="images/frndlytv_logo.png" alt="frndlytv" />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6 align">
							<img className="mobile-channel-logo" alt={this.props.order[0]} src={channelLogos[this.props.order[0]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<img className="mobile-channel-logo" alt={this.props.order[1]} src={channelLogos[this.props.order[1]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<img className="mobile-channel-logo" alt={this.props.order[2]} src={channelLogos[this.props.order[2]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
				</div>

				<div className="single-mobile-provider">
					<div className="row">
						<div className="col-xs-6"><h3 className="mobile-provider-heading">Other Provider:</h3></div>
						<div className="col-xs-6 align-center">
							<img className="mobile-provider-logo" src="images/logo_fubo.png" alt="Fubo TV" />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6 align">
							<img className="mobile-channel-logo" alt={this.props.order[0]} src={channelLogos[this.props.order[0]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<img className="mobile-channel-logo" alt={this.props.order[1]} src={channelLogos[this.props.order[1]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<img className="mobile-channel-logo" alt={this.props.order[2]} src={channelLogos[this.props.order[2]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
				</div>
				<div className="single-mobile-provider">
					<div className="row">
						<div className="col-xs-6"><h3 className="mobile-provider-heading">Other Provider:</h3></div>
						<div className="col-xs-6 align-center">
							<img className="mobile-provider-logo" src="images/hulu-livetv.full.png" alt="Hulu+livetv" />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6 align">
							<img className="mobile-channel-logo" alt={this.props.order[0]} src={channelLogos[this.props.order[0]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<img className="mobile-channel-logo" alt={this.props.order[1]} src={channelLogos[this.props.order[1]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<img className="mobile-channel-logo" alt={this.props.order[2]} src={channelLogos[this.props.order[2]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
				</div>

				{/* <div className="single-mobile-provider">
					<div className="row">
						<div className="col-xs-6"><h3 className="mobile-provider-heading">Other Provider:</h3></div>
						<div className="col-xs-6 align-center">
							<img className="mobile-provider-logo" src="/images/NBCUniversal_Peacock_Logo.png" alt="Peacock" />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6 align">
							<img className="mobile-channel-logo" alt={this.props.order[0]} src={channelLogos[this.props.order[0]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<img className="mobile-channel-logo" alt={this.props.order[1]} src={channelLogos[this.props.order[1]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<img className="mobile-channel-logo" alt={this.props.order[2]} src={channelLogos[this.props.order[2]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
				</div> */}
				<div className="single-mobile-provider">
					<div className="row">
						<div className="col-xs-6"><h3 className="mobile-provider-heading">Other Provider:</h3></div>
						<div className="col-xs-6 align-center">
							<img className="mobile-provider-logo" src="images/philo-logo.png" alt="Philo" />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6 align">
							<img className="mobile-channel-logo" alt={this.props.order[0]} src={channelLogos[this.props.order[0]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<img className="mobile-channel-logo" alt={this.props.order[1]} src={channelLogos[this.props.order[1]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<img className="mobile-channel-logo" alt={this.props.order[2]} src={channelLogos[this.props.order[2]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
				</div>
				<div className="single-mobile-provider">
					<div className="row">
						<div className="col-xs-6"><h3 className="mobile-provider-heading">Other Provider:</h3></div>
						<div className="col-xs-6 align-center">
							<img className="mobile-provider-logo" src="images/Sling_TV_logo.svg" alt="Sling TV" />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6 align">
							<img className="mobile-channel-logo" alt={this.props.order[0]} src={channelLogos[this.props.order[0]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<img className="mobile-channel-logo" alt={this.props.order[1]} src={channelLogos[this.props.order[1]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<img className="mobile-channel-logo" alt={this.props.order[2]} src={channelLogos[this.props.order[2]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
				</div>

				{/* <div className="single-mobile-provider">
					<div className="row">
						<div className="col-xs-6"><h3 className="mobile-provider-heading">Other Provider:</h3></div>
						<div className="col-xs-6 align-center">
						<img className="mobile-provider-logo" src="https://www.hallmarkchanneleverywhere.com/content/logos/Vidgo-Primary-Logo-RGB.png" alt="Vidgo" />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6 align">
							<img className="mobile-channel-logo" alt={this.props.order[0]} src={channelLogos[this.props.order[0]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<img className="mobile-channel-logo" alt={this.props.order[1]} src={channelLogos[this.props.order[1]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<img className="mobile-channel-logo" alt={this.props.order[2]} src={channelLogos[this.props.order[2]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
				</div> */}
				<div className="single-mobile-provider">
					<div className="row">
						<div className="col-xs-6"><h3 className="mobile-provider-heading">Other Provider:</h3></div>
						<div className="col-xs-6 align-center">
						<img className="provider-logo" src="/images/YouTube_TV_logo.svg" alt="YouTube TV" />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6 align">
							<img className="mobile-channel-logo" alt={this.props.order[0]} src={channelLogos[this.props.order[0]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<img className="mobile-channel-logo" alt={this.props.order[1]} src={channelLogos[this.props.order[1]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<img className="mobile-channel-logo" alt={this.props.order[2]} src={channelLogos[this.props.order[2]]} />
						</div>
						<div className="col-xs-6 align-center">
							<FontAwesome className='provider-check' name='check-circle' />
						</div>
					</div>
				</div>
			</Fragment>
		)
	}
}

export default OtherProvidersMobileTable;


// WEBPACK FOOTER //
// ./src/components/OtherProvidersMobileTable.js